const GooglePlayIcon = () => {
  return (
    <svg
      width="140"
      height="43"
      viewBox="0 0 150 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M145.736 43H4.26388C1.9105 43 0 41.0931 0 38.7442V4.2558C0 1.90687 1.9105 0 4.26388 0H145.736C148.089 0 150 1.90687 150 4.2558V38.7442C150.009 41.0931 148.098 43 145.736 43Z"
        fill="black"
      />
      <path
        d="M75.2542 23.5934C72.7705 23.5934 70.7558 25.4742 70.7558 28.0659C70.7558 30.6401 72.7792 32.5383 75.2542 32.5383C77.7378 32.5383 79.7525 30.6401 79.7525 28.0659C79.7612 25.4742 77.7378 23.5934 75.2542 23.5934ZM75.2542 30.7788C73.8908 30.7788 72.7184 29.6607 72.7184 28.0659C72.7184 26.4537 73.8908 25.3529 75.2542 25.3529C76.6176 25.3529 77.7813 26.4537 77.7813 28.0659C77.7899 29.6607 76.6176 30.7788 75.2542 30.7788ZM65.4325 23.5934C62.9489 23.5934 60.9342 25.4742 60.9342 28.0659C60.9342 30.6401 62.9575 32.5383 65.4325 32.5383C67.9161 32.5383 69.9309 30.6401 69.9309 28.0659C69.9395 25.4742 67.9161 23.5934 65.4325 23.5934ZM65.4325 30.7788C64.0691 30.7788 62.8968 29.6607 62.8968 28.0659C62.8968 26.4537 64.0691 25.3529 65.4325 25.3529C66.7959 25.3529 67.9596 26.4537 67.9596 28.0659C67.9683 29.6607 66.7959 30.7788 65.4325 30.7788ZM53.7524 24.9629V26.8611H58.3029C58.1639 27.9272 57.8079 28.7073 57.2695 29.2533C56.6095 29.9121 55.5674 30.6401 53.7524 30.6401C50.9475 30.6401 48.7591 28.3866 48.7591 25.5869C48.7591 22.7873 50.9475 20.5337 53.7524 20.5337C55.2635 20.5337 56.3663 21.1231 57.1826 21.8945L58.5287 20.551C57.3911 19.4676 55.88 18.6355 53.7524 18.6355C49.9141 18.6355 46.6836 21.7558 46.6836 25.5869C46.6836 29.418 49.9141 32.5383 53.7524 32.5383C55.8279 32.5383 57.3911 31.8623 58.6155 30.5881C59.8747 29.3313 60.2655 27.5718 60.2655 26.1416C60.2655 25.6996 60.2307 25.2922 60.1613 24.9542H53.7524V24.9629ZM101.532 26.4363C101.159 25.4396 100.021 23.5847 97.6938 23.5847C95.3839 23.5847 93.4647 25.3962 93.4647 28.0572C93.4647 30.5708 95.3665 32.5297 97.9196 32.5297C99.9777 32.5297 101.167 31.2729 101.654 30.5448L100.125 29.5307C99.613 30.2761 98.9183 30.7701 97.9196 30.7701C96.9209 30.7701 96.2002 30.3108 95.7486 29.4093L101.749 26.9304L101.532 26.4363ZM95.4099 27.9272C95.3578 26.1937 96.7559 25.3182 97.7546 25.3182C98.5362 25.3182 99.1962 25.7083 99.422 26.2717L95.4099 27.9272ZM90.5382 32.2696H92.5094V19.1122H90.5382V32.2696ZM87.3077 24.5901H87.2382C86.7953 24.0614 85.9443 23.5934 84.8761 23.5934C82.6357 23.5934 80.5775 25.5609 80.5775 28.0832C80.5775 30.5968 82.6357 32.547 84.8761 32.547C85.9443 32.547 86.7953 32.0703 87.2382 31.5329H87.3077V32.1743C87.3077 33.8905 86.3872 34.8006 84.9109 34.8006C83.7038 34.8006 82.957 33.9338 82.653 33.2057L80.9336 33.9165C81.4286 35.104 82.7312 36.5601 84.9109 36.5601C87.2208 36.5601 89.1748 35.1993 89.1748 31.8969V23.8621H87.3077V24.5901ZM85.0498 30.7788C83.6864 30.7788 82.5488 29.6434 82.5488 28.0832C82.5488 26.5057 83.6864 25.3529 85.0498 25.3529C86.3959 25.3529 87.4466 26.5057 87.4466 28.0832C87.4466 29.6434 86.3959 30.7788 85.0498 30.7788ZM110.763 19.1122H106.048V32.2696H108.019V27.2858H110.763C112.943 27.2858 115.088 25.7083 115.088 23.2033C115.088 20.6984 112.943 19.1122 110.763 19.1122ZM110.815 25.4569H108.019V20.9497H110.815C112.283 20.9497 113.125 22.1632 113.125 23.2033C113.117 24.2174 112.283 25.4569 110.815 25.4569ZM122.973 23.5674C121.549 23.5674 120.073 24.1914 119.465 25.5783L121.21 26.3063C121.584 25.5783 122.278 25.3442 123.008 25.3442C124.024 25.3442 125.057 25.951 125.075 27.0344V27.1731C124.719 26.9737 123.954 26.6617 123.025 26.6617C121.141 26.6617 119.23 27.6931 119.23 29.626C119.23 31.3855 120.776 32.521 122.504 32.521C123.824 32.521 124.554 31.9316 125.014 31.2382H125.083V32.2523H126.985V27.2078C126.977 24.8675 125.231 23.5674 122.973 23.5674ZM122.739 30.7788C122.096 30.7788 121.193 30.4581 121.193 29.6607C121.193 28.6466 122.313 28.2565 123.277 28.2565C124.146 28.2565 124.545 28.4386 125.075 28.6986C124.927 29.9121 123.876 30.7788 122.739 30.7788ZM133.898 23.8534L131.64 29.5567H131.57L129.226 23.8534H127.107L130.615 31.8276L128.618 36.2654H130.667L136.077 23.8534H133.898ZM116.174 32.2696H118.145V19.1122H116.174V32.2696Z"
        fill="white"
      />
      <path
        d="M14.4043 8.63367C14.1003 8.95437 13.918 9.4571 13.918 10.1158V33.397C13.918 34.0471 14.1003 34.5498 14.4043 34.8792L14.4824 34.9572L27.5433 21.9211V21.7651V21.6091L14.4824 8.55566L14.4043 8.63367Z"
        fill="url(#paint0_linear_201_613)"
      />
      <path
        d="M31.9015 26.2458L27.5508 21.8946V21.7386V21.5826L31.9102 17.2314L32.0057 17.2835L37.164 20.2131C38.6403 21.0452 38.6403 22.4147 37.164 23.2554L32.0057 26.1851L31.9015 26.2458Z"
        fill="url(#paint1_linear_201_613)"
      />
      <path
        d="M32.0089 26.1933L27.5539 21.7468L14.4062 34.8609C14.8926 35.3723 15.6915 35.4416 16.5946 34.9216L32.0089 26.1933Z"
        fill="url(#paint2_linear_201_613)"
      />
      <path
        d="M32.008 17.3005L16.6024 8.56354C15.6993 8.05215 14.9004 8.11282 14.4141 8.62421L27.5531 21.7383L32.008 17.3005Z"
        fill="url(#paint3_linear_201_613)"
      />
      <path
        opacity="0.2"
        d="M31.9038 26.0984L16.6024 34.7747C15.7427 35.2601 14.9785 35.2254 14.4922 34.7833L14.4141 34.8613L14.4922 34.9393C14.9872 35.3814 15.7514 35.4161 16.6024 34.9307L32.008 26.1937L31.9038 26.0984Z"
        fill="black"
      />
      <path
        opacity="0.12"
        d="M14.4043 34.7141C14.1003 34.3934 13.918 33.8907 13.918 33.2319V33.388C13.918 34.038 14.1003 34.5407 14.4043 34.8701L14.4824 34.7921L14.4043 34.7141Z"
        fill="black"
      />
      <path
        opacity="0.12"
        d="M37.164 23.1163L31.9102 26.098L32.0057 26.1933L37.164 23.2637C37.9022 22.8476 38.2669 22.2929 38.2669 21.7468C38.2061 22.2495 37.8327 22.7349 37.164 23.1163Z"
        fill="black"
      />
      <path
        opacity="0.25"
        d="M16.6013 8.71961L37.1652 20.3775C37.8339 20.7589 38.2073 21.2443 38.2681 21.747C38.2681 21.1923 37.9034 20.6462 37.1652 20.2302L16.6013 8.5636C15.1251 7.73151 13.918 8.42492 13.918 10.1064V10.2624C13.918 8.58093 15.1251 7.87886 16.6013 8.71961Z"
        fill="white"
      />
      <path
        d="M46.9961 14.3797V8.06104H48.9326C49.9053 8.06104 50.6781 8.35573 51.2687 8.93646C51.8505 9.51719 52.1457 10.2799 52.1457 11.216C52.1457 12.1521 51.8505 12.9149 51.2687 13.4956C50.6868 14.085 49.9053 14.3711 48.9326 14.3711H46.9961V14.3797ZM47.8037 13.5996H48.924C49.6534 13.5996 50.2353 13.3916 50.6608 12.9756C51.0863 12.5595 51.3034 11.9701 51.3034 11.2247C51.3034 10.4793 51.0863 9.89857 50.6608 9.47386C50.2353 9.05781 49.6534 8.84112 48.924 8.84112H47.8037V13.5996Z"
        fill="white"
        stroke="white"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M53.2734 14.3797V8.06104H54.0897V14.3797H53.2734Z"
        fill="white"
        stroke="white"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M57.3229 14.5184C56.8627 14.5184 56.4111 14.3711 55.9769 14.0677C55.534 13.7643 55.2474 13.3483 55.1172 12.8022L55.864 12.4989C55.9509 12.8456 56.1332 13.1403 56.4024 13.3743C56.6803 13.6083 56.9843 13.7297 57.3229 13.7297C57.679 13.7297 57.9829 13.6343 58.2261 13.4523C58.4779 13.2703 58.5995 13.0189 58.5995 12.6982C58.5995 12.3428 58.4779 12.0741 58.2261 11.8835C57.9742 11.6928 57.5835 11.5108 57.0364 11.3461C56.4719 11.1727 56.0551 10.9387 55.7598 10.6613C55.4732 10.384 55.3256 10.0286 55.3256 9.58655C55.3256 9.13583 55.508 8.73712 55.864 8.40775C56.2201 8.06971 56.689 7.90503 57.2708 7.90503C57.8092 7.90503 58.2434 8.03504 58.5821 8.30374C58.9208 8.57244 59.1379 8.86713 59.2334 9.17917L58.4953 9.4912C58.4432 9.29185 58.3129 9.10983 58.1045 8.93647C57.8961 8.76312 57.6269 8.68511 57.2969 8.68511C56.9843 8.68511 56.7151 8.77179 56.498 8.94514C56.2722 9.11849 56.168 9.33518 56.168 9.59521C56.168 9.82924 56.2722 10.0286 56.4719 10.1933C56.6716 10.358 56.9756 10.4966 57.3664 10.6267C57.679 10.7307 57.9395 10.826 58.1479 10.9214C58.3563 11.0167 58.5734 11.138 58.7819 11.2941C58.999 11.4501 59.1553 11.6408 59.2682 11.8748C59.3811 12.1088 59.4332 12.3775 59.4332 12.6809C59.4332 12.9842 59.3724 13.2616 59.2421 13.5043C59.1119 13.747 58.9469 13.9377 58.7384 14.0764C58.53 14.215 58.3042 14.3277 58.0611 14.3971C57.8266 14.4837 57.5835 14.5184 57.3229 14.5184Z"
        fill="white"
        stroke="white"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M61.4218 14.3797H60.6055V8.06104H62.7591C63.2975 8.06104 63.7578 8.24305 64.1486 8.59843C64.5394 8.9538 64.7391 9.40451 64.7391 9.94191C64.7391 10.4793 64.5394 10.93 64.1486 11.2854C63.7578 11.6408 63.2888 11.8228 62.7591 11.8228H61.4131V14.3797H61.4218ZM61.4218 11.0427H62.7852C63.1238 11.0427 63.4017 10.93 63.6102 10.696C63.8186 10.462 63.9228 10.2106 63.9228 9.93324C63.9228 9.65587 63.8186 9.40451 63.6102 9.17049C63.4017 8.93646 63.1325 8.82378 62.7852 8.82378H61.4218V11.0427Z"
        fill="white"
        stroke="white"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M70.9376 13.5649C70.3123 14.2063 69.5395 14.5183 68.6189 14.5183C67.6984 14.5183 66.9169 14.1976 66.3003 13.5649C65.675 12.9235 65.3711 12.1434 65.3711 11.2246C65.3711 10.3058 65.6837 9.51708 66.3003 8.88435C66.9255 8.24294 67.6984 7.93091 68.6189 7.93091C69.5395 7.93091 70.3123 8.25161 70.9376 8.89301C71.5628 9.53442 71.8755 10.3145 71.8755 11.2333C71.8668 12.1434 71.5628 12.9235 70.9376 13.5649ZM66.8995 13.0361C67.3684 13.5128 67.9416 13.7469 68.6189 13.7469C69.2963 13.7469 69.8694 13.5128 70.3384 13.0361C70.8073 12.5594 71.0418 11.9613 71.0418 11.2246C71.0418 10.4879 70.8073 9.88112 70.3384 9.41307C69.8694 8.93635 69.2963 8.70233 68.6189 8.70233C67.9416 8.70233 67.3684 8.93635 66.8995 9.41307C66.4306 9.88979 66.1961 10.4879 66.1961 11.2246C66.1961 11.9613 66.4306 12.5594 66.8995 13.0361Z"
        fill="white"
        stroke="white"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M73.0117 14.3797V8.06104H74.0017L77.0759 12.9756H77.1106L77.0759 11.7621V8.06104H77.8922V14.3797H77.0411L73.828 9.23116H73.7933L73.828 10.4446V14.3797H73.0117Z"
        fill="white"
        stroke="white"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M79.3359 14.3795V8.06078H80.1522V14.3795H79.3359ZM80.1001 7.56673H79.3967L79.857 6.43994H80.7428L80.1001 7.56673Z"
        fill="white"
        stroke="white"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M83.1645 14.3797L80.9414 8.06104H81.8446L83.5727 13.1836H83.6074L85.405 8.06104H86.3082L84.0069 14.3797H83.1645Z"
        fill="white"
        stroke="white"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M90.929 8.84112H88.0459V10.8433H90.6424V11.6061H88.0459V13.6083H90.929V14.3884H87.2383V8.06104H90.929V8.84112Z"
        fill="white"
        stroke="white"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M92.1953 14.3797V8.06104H93.0116V13.5996H95.7471V14.3797H92.1953Z"
        fill="white"
        stroke="white"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M98.8906 14.3797V8.06104H99.8806L102.955 12.9756H102.99L102.955 11.7621V8.06104H103.771V14.3797H102.92L99.7069 9.23116H99.6722L99.7069 10.4446V14.3797H98.8906Z"
        fill="white"
        stroke="white"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M110.399 13.5649C109.773 14.2063 109 14.5183 108.08 14.5183C107.159 14.5183 106.378 14.1976 105.761 13.5649C105.136 12.9235 104.832 12.1434 104.832 11.2246C104.832 10.3058 105.145 9.51708 105.761 8.88435C106.386 8.24294 107.159 7.93091 108.08 7.93091C109 7.93091 109.773 8.25161 110.399 8.89301C111.024 9.53442 111.336 10.3145 111.336 11.2333C111.328 12.1434 111.015 12.9235 110.399 13.5649ZM106.36 13.0361C106.829 13.5128 107.403 13.7469 108.08 13.7469C108.757 13.7469 109.33 13.5128 109.799 13.0361C110.268 12.5594 110.503 11.9613 110.503 11.2246C110.503 10.4879 110.268 9.88112 109.799 9.41307C109.33 8.93635 108.757 8.70233 108.08 8.70233C107.403 8.70233 106.829 8.93635 106.36 9.41307C105.891 9.88979 105.657 10.4879 105.657 11.2246C105.657 11.9613 105.891 12.5594 106.36 13.0361Z"
        fill="white"
        stroke="white"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <defs>
        <linearGradient
          id="paint0_linear_201_613"
          x1="26.3903"
          y1="9.86327"
          x2="8.72589"
          y2="27.5612"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset="0.00657445" stopColor="#00A1FF" />
          <stop offset="0.2601" stopColor="#00BEFF" />
          <stop offset="0.5122" stopColor="#00D2FF" />
          <stop offset="0.7604" stopColor="#00DFFF" />
          <stop offset="1" stopColor="#00E3FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_201_613"
          x1="39.0803"
          y1="21.7479"
          x2="13.5633"
          y2="21.7479"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE000" />
          <stop offset="0.4087" stopColor="#FFBD00" />
          <stop offset="0.7754" stopColor="#FFA500" />
          <stop offset="1" stopColor="#FF9C00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_201_613"
          x1="29.5846"
          y1="24.1627"
          x2="5.6303"
          y2="48.1626"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF3A44" />
          <stop offset="1" stopColor="#C31162" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_201_613"
          x1="11.0978"
          y1="0.880448"
          x2="21.7944"
          y2="11.5974"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#32A071" />
          <stop offset="0.0685" stopColor="#2DA771" />
          <stop offset="0.4762" stopColor="#15CF74" />
          <stop offset="0.8009" stopColor="#06E775" />
          <stop offset="1" stopColor="#00F076" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default GooglePlayIcon
